var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import PropTypes from "prop-types";
var variantsMapping = {
    heading01: "h1",
    heading02: "h2",
    heading03: "h3",
    heading04: "h4",
    heading05: "h5",
    logotypeInline: "h2",
    logotypeSolid: "h2",
    body01Regular: "span",
    body01Semibold: "span",
    body02Regular: "span",
    body02Semibold: "span",
    metadataRegular: "span",
    metadataSemibold: "span",
};
var clName = function (suffix) {
    if (suffix === void 0) { suffix = ""; }
    var mainClassName = "mex-typography";
    return "".concat(mainClassName).concat(suffix);
};
export var Typography = function (_a) {
    var _b;
    var variant = _a.variant, children = _a.children, onClick = _a.onClick, _c = _a.className, className = _c === void 0 ? "" : _c, otherProps = __rest(_a, ["variant", "children", "onClick", "className"]);
    var Component = variant ? variantsMapping[variant] : "span";
    var classNames = classnames((_b = {},
        _b[clName("--".concat(variant))] = true,
        _b[className] = className,
        _b));
    return (_jsx(Component, __assign({ className: classNames }, otherProps, { onClick: onClick }, { children: children })));
};
Typography.propTypes = {
    variant: PropTypes.oneOf([
        "logotypeInline",
        "logotypeSolid",
        "heading01",
        "heading02",
        "heading03",
        "heading04",
        "heading05",
        "body01Regular",
        "body01Semibold",
        "body02Regular",
        "body02Semibold",
        "metadataRegular",
        "metadataSemibold",
    ]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
};
export default Typography;
